import { Alert, AlertTitle, Link, Stack, Typography } from "@mui/material";
import { RejectionGroups } from "Components/Merchant/OrbitL/RejectionGroups";
import type { RejectionGroupDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Components.Merchant.OrbitL;

type Props = {
  groups: Array<RejectionGroupDto>;
  isSelfEmployed: boolean;
};

/**
 * What the processor sent back, shown to the merchant. Only they can fix the documents, so a bare
 * "processing" state left them waiting on a correction nobody had asked them for.
 */
export const OrbitLRejectionPanel = ({ groups, isSelfEmployed }: Props) => {
  const { t } = useResource();

  const activeTab = isSelfEmployed ? "party" : "relatedParties";
  const settingsLink = `${appUrl("user-account")}?activeTab=${activeTab}`;

  return (
    <Alert severity="warning">
      <AlertTitle>{t(RESOURCES.Rejection.Title)}</AlertTitle>
      <Stack gap={2}>
        <Typography variant="body2">{t(RESOURCES.Rejection.Intro)}</Typography>
        <RejectionGroups groups={groups} />
        <Link href={settingsLink}>
          {t(RESOURCES.Checklist.GoToSettingsLink)}
        </Link>
      </Stack>
    </Alert>
  );
};
